import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { updateMe } from '../../services/authService';
import { useToast } from '../../context/ToastContext';

const ClientProfileForm = () => {
  const { user, refresh } = useAuth();
  const toast = useToast();
  const [form, setForm] = useState({
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    phone: user?.phone || ''
  });
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateMe(form);
      await refresh();
      toast.success('Profile updated');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not update profile');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSave} className="bg-white p-6 rounded-lg shadow space-y-4 max-w-lg">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">First name</label>
          <input name="firstName" value={form.firstName} onChange={handleChange}
            className="w-full p-2.5 border rounded-lg" required />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Last name</label>
          <input name="lastName" value={form.lastName} onChange={handleChange}
            className="w-full p-2.5 border rounded-lg" required />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Phone</label>
        <input name="phone" value={form.phone} onChange={handleChange}
          className="w-full p-2.5 border rounded-lg" required />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Email</label>
        <input value={user?.email || ''} disabled className="w-full p-2.5 border rounded-lg bg-gray-100 text-gray-500" />
        <p className="text-xs text-gray-400 mt-1">Contact support to change your email address.</p>
      </div>
      <button type="submit" disabled={saving}
        className="bg-primary-dark text-secondary px-4 py-2 rounded-lg hover:bg-accent-hard hover:text-primary-dark disabled:opacity-50">
        {saving ? 'Saving...' : 'Save changes'}
      </button>
    </form>
  );
};

export default ClientProfileForm;
